import React from 'react';

const Cart = () => {
  return (
    <div className="min-h-screen bg-gray-100 py-10">
      <div className="text-center mb-10">
        <h1 className="font-extrabold text-4xl md:text-5xl text-gray-800">Your Cart</h1>
      </div>

      <div className="flex justify-center items-center">
        <div className="max-w-sm bg-white rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
          <img
            src="https://ng.jumia.is/unsafe/fit-in/500x500/filters:fill(white)/product/89/8491651/1.jpg?9655"
            alt="Oraimo 20000mAh Powerbank"
            className="rounded-t-lg w-full"
          />
          <div className="p-6">
            <p className="text-lg text-gray-700 font-semibold mb-2">
              <span className="font-bold">Price:</span> N22,200
            </p>
            <p className="text-lg text-gray-700 font-semibold mb-4">
              <span className="font-bold">Description:</span> Oraimo 20000mAh Powerbank
            </p>
            <button className="w-full cursor-not-allowed py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors duration-300">
              waiting for payment confirmation...
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Cart;
